import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import { FaXmark } from "react-icons/fa6";
import { useSelector } from "react-redux";
import BeatLoader from "react-spinners/BeatLoader";
import { useUpdateProfileMutation } from "../../Data/services/notificationApi";
import { SuccessToast } from "../../Hooks/useToast";
import { Description } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";

const SettingModal = ({
  handleSettingModal,
  show_motion = false,
  show_perspiration = false,
  show_temperature = false,
  setMotion,
  setPrespiration,
  setTemperature,
  isFetching,
}) => {
  const login_User = useSelector((state) => state.authInfo?.user?.id);
  const [updateProfile] = useUpdateProfileMutation();

  const handleSubmit = async () => {
    try {
      const response = await updateProfile({
        show_motion: show_motion ? 1 : 0,
        show_perspiration: show_perspiration ? 1 : 0,
        show_temperature: show_temperature ? 1 : 0,
      });

      if (response.data.code === 200) {
        // SuccessToast("User updated");
        // refetch();
      }
    } catch (error) {
      console.error("Error updating profile", error);
    }
  };

  const handleOnchange = (type) => {
    switch (type) {
      case "temperature":
        setTemperature(!show_temperature);
        break;
      case "perspiration":
        setPrespiration(!show_perspiration);
        break;
      case "motion":
        setMotion(!show_motion);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    handleSubmit();
  }, [show_temperature, show_perspiration, show_motion]);

  console.log(
    "show_temperature :",
    show_temperature,
    "show_perspiration :",
    show_perspiration,
    "show_motion :",
    show_motion
  );

  return (
    <div>
      <ModalContainer handleClose={handleSettingModal}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0">Settings</p>
            <span
              className={`${cssStyles.xmark} bg-opacity-75 d-flex p-3 rounded-5`}
            >
              <FaXmark
                role="button"
                onClick={handleSettingModal}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          {isFetching ? (
            <div className="w-100 d-flex justify-content-center align-items-center h-100">
              <BeatLoader size={20} />
            </div>
          ) : (
            <div className={cssStyles.Menu}>
              <div className={`${cssStyles.option} my-3 fs-4`}>
                <Description text={"Temperature"} classes="fs-7" />
                <Form>
                  <Form.Check
                    type="switch"
                    checked={show_temperature}
                    onChange={() => {
                      handleOnchange("temperature");
                    }}
                  />
                </Form>
              </div>
              <div className={`${cssStyles.option} my-3 fs-4`}>
                <Description text={"Motion"} classes="fs-7" />
                <Form>
                  <Form.Check
                    type="switch"
                    checked={show_motion}
                    onChange={() => {
                      handleOnchange("motion");
                    }}
                  />
                </Form>
              </div>
              <div className={`${cssStyles.option} my-3 fs-4`}>
                <Description text={"Perspiration"} classes="fs-7" />
                <Form>
                  <Form.Check
                    type="switch"
                    checked={show_perspiration}
                    onChange={() => {
                      handleOnchange("perspiration");
                    }}
                  />
                </Form>
              </div>
            </div>
          )}
        </div>
      </ModalContainer>
    </div>
  );
};

export default SettingModal;
